<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> {{$t('pages.washingReport.breadcrumb')}} </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container">
        <div>
            <div class="handle-headleft">
                <el-button type="success" icon="el-icon-takeaway-box" @click="exportlist">{{$t('pages.washingReport.export')}}</el-button>
            </div>
            <div class="handle-headright">
                <el-date-picker v-model="query.startDate" type="date" :placeholder="$t('pages.washingReport.selectDate')" class="handle-select mr10" style="width: 130px"></el-date-picker>
                <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.washingReport.search')}}</el-button>
            </div>
        </div>

        <el-table :data="tableData" border :span-method="objectSpanMethod" show-summary :summary-method="getSummaries" class="table" header-cell-class-name="table-header" :height="tableHeight" ref="table">
            <el-table-column :label="$t('pages.washingReport.title')" align="center">
                <el-table-column prop="index" width="50" :label="$t('pages.washingReport.index')" align="center"></el-table-column>
                <el-table-column prop="mineName" :label="$t('pages.washingReport.mineName')" align="center"></el-table-column>
                <el-table-column prop="indicatorName" :label="$t('pages.washingReport.indicatorName')" align="center" width="140"></el-table-column>
                <el-table-column :label="$t('pages.washingReport.selectedCoal')" align="center">
                    <el-table-column prop="selectedCoalToday" :label="$t('pages.washingReport.day')" align="center" width="120"></el-table-column>
                    <el-table-column prop="selectedCoalMonth" :label="$t('pages.washingReport.month')" align="center" width="120"></el-table-column>
                    <el-table-column prop="selectedCoalYear" :label="$t('pages.washingReport.year')" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column :label="$t('pages.washingReport.rawCoal')" align="center">
                    <el-table-column prop="rawCoalToday" :label="$t('pages.washingReport.day')" align="center" width="120"></el-table-column>
                    <el-table-column prop="rawCoalMonth" :label="$t('pages.washingReport.month')" align="center" width="120"></el-table-column>
                    <el-table-column prop="rawCoalYear" :label="$t('pages.washingReport.year')" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column :label="$t('pages.washingReport.cleanCoal')" align="center">
                    <el-table-column prop="cleanCoalToday" :label="$t('pages.washingReport.day')" align="center" width="120"></el-table-column>
                    <el-table-column prop="cleanCoalMonth" :label="$t('pages.washingReport.month')" align="center" width="120"></el-table-column>
                    <el-table-column prop="cleanCoalYear" :label="$t('pages.washingReport.year')" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column :label="$t('pages.washingReport.lumpCoal')" align="center">
                    <el-table-column prop="lumpCoalToday" :label="$t('pages.washingReport.day')" align="center" width="120"></el-table-column>
                    <el-table-column prop="lumpCoalMonth" :label="$t('pages.washingReport.month')" align="center" width="120"></el-table-column>
                    <el-table-column prop="lumpCoalYear" :label="$t('pages.washingReport.year')" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column :label="$t('pages.washingReport.mediumCoal')" align="center">
                    <el-table-column prop="mediumCoalToday" :label="$t('pages.washingReport.day')" align="center" width="120"></el-table-column>
                    <el-table-column prop="mediumCoalMonth" :label="$t('pages.washingReport.month')" align="center" width="120"></el-table-column>
                    <el-table-column prop="mediumCoalYear" :label="$t('pages.washingReport.year')" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column :label="$t('pages.washingReport.slurry')" align="center">
                    <el-table-column prop="slurryToday" :label="$t('pages.washingReport.day')" align="center" width="120"></el-table-column>
                    <el-table-column prop="slurryMonth" :label="$t('pages.washingReport.month')" align="center" width="120"></el-table-column>
                    <el-table-column prop="slurryYear" :label="$t('pages.washingReport.year')" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column :label="$t('pages.washingReport.sieveCoal')" align="center">
                    <el-table-column prop="sieveCoalToday" :label="$t('pages.washingReport.day')" align="center" width="120"></el-table-column>
                    <el-table-column prop="sieveCoalMonth" :label="$t('pages.washingReport.month')" align="center" width="120"></el-table-column>
                    <el-table-column prop="sieveCoalYear" :label="$t('pages.washingReport.year')" align="center" width="120"></el-table-column>
                </el-table-column>
            </el-table-column>

        </el-table>
    </div>
</div>
</template>

<script>
import {
    dateFormat,
    SortField,
    dateAdd
} from '../../utils/helper';
import print from 'print-js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'logRecord',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                }
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                },
            },
            provinceArr: [],
            tableHeight: window.innerHeight * 0.75,
            totalWeight: '',
            frequencyArr: [],
            balanceArr: [],
            logRecords: [],
            multipleSelection: [],
            query: {
                startDate: '',
            },
            tableData: []
        };

    },
    filters: {
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy-MM-dd');
        }
    },
    created() {
        const start = new Date();
        //start.setTime(start.getTime() + 3600 * 1000 * 24);
        this.query.startDate = start;
        this.getData();
    },
    methods: {
        //自定义方法
        getSummaries(param) {
            const {
                columns,
                data
            } = param;
            const sums = {};
            let newData = [];
            for (let i = 0; i < data.length; i++) {
                if (data[i].indicatorName == this.$t('pages.washingReport.prodT')) {
                    newData[i] = data[i];
                }
            }
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = this.$t('pages.washingReport.companyTotal');
                    return;
                }
                if (index === 1) {
                    sums[index] = this.$t('pages.washingReport.prodT');
                    return;
                }
                const values = newData.map(item => Number(item[column.property]));
                if (column.label != this.$t('pages.washingReport.index') && column.label != this.$t('pages.washingReport.mineName') && column.label != this.$t('pages.washingReport.indicatorName')) {
                    if (!values.every(value => isNaN(value))) {
                        sums[index - 1] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index - 1] = sums[index - 1].toFixed(2); // 保留2位小数
                    }
                }
            });
            return sums;
        },
        mergeCol(id, rowIndex) { // 合并单元格
            // id：属性名
            // rowIndex：行索引值
            var idName = this.tableData[rowIndex][id] // 获取当前单元格的值
            if (rowIndex > 0) { // 判断是不是第一行
                // eslint-disable-next-line eqeqeq
                if (this.tableData[rowIndex][id] != this.tableData[rowIndex - 1][id]) { // 先判断当前单元格的值是不是和上一行的值相等
                    var i = rowIndex;
                    var num = 0 // 定义一个变量i，用于记录行索引值并进行循环，num用于计数
                    while (i < this.tableData.length) { // 当索引值小于table的数组长度时，循环执行
                        if (this.tableData[i][id] === idName) { // 判断循环的单元格的值是不是和当前行的值相等
                            i++ // 如果相等，则索引值加1
                            num++ // 合并的num计数加1
                        } else {
                            i = this.tableData.length // 如果不相等，将索引值设置为table的数组长度，跳出循环
                        }
                    }
                    return {
                        rowspan: num, // 最终将合并的行数返回
                        colspan: 1
                    }
                } else {
                    return {
                        rowspan: 0, // 如果相等，则将rowspan设置为0
                        colspan: 1
                    }
                }
            } else { // 如果是第一行，则直接返回
                let i = rowIndex;
                let num = 0
                while (i < this.tableData.length) { // 当索引值小于table的数组长度时，循环执行
                    if (this.tableData[i][id] === idName) {
                        i++
                        num++
                    } else {
                        i = this.tableData.length
                    }
                }
                return {
                    rowspan: num,
                    colspan: 1
                }
            }
        },
        objectSpanMethod({
            row,
            column,
            rowIndex,
            columnIndex
        }) { // 合并单元格
            switch (columnIndex) { // 将列索引作为判断值
                // 通过传递不同的列索引和需要合并的属性名，可以实现不同列的合并
                case 0:
                    return this.mergeCol('index', rowIndex)
                case 1:
                    return this.mergeCol('mineName', rowIndex)
            }
            this.$nextTick(x => {
                if (this.$refs.table.$el) {
                    var current = this.$refs.table.$el
                        .querySelector(".el-table__footer-wrapper")
                        .querySelector(".el-table__footer");
                    var cell = current.rows[0].cells;
                    cell[0].colSpan = "2";
                    cell[0].rowSpan = "1";
                    cell[1].rowSpan = "1";
                    cell[2].rowSpan = "1";
                }
                this.$refs['table'].doLayout();
            })
        },
        getData() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.isAdmin = userInfo.id == 1 ? true : false;
            if (this.query.startDate == null) {
                this.$notify.warning(this.$t('pages.washingReport.dateRequired'));
                return;
            }
            this.query.startDate = new Date(dateFormat.formatDate(this.query.startDate, 'yyyy-MM-dd 08:00:00'));
            this.query.loginId = userInfo.loginId;
            this.query.userType = userInfo.userType;
            this.$zybhttp
                .post('WashingProductReport/WashingProductDailyReportData', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.tableData = d;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.washingReport.fetchError')));
        },
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy-MM-dd');
        },
        exportlist() {
            let date = new Date();
            let name = dateFormat.formatDate(date, 'yyyyMMddhhmm');
            var wb = XLSX.utils.table_to_book(document.querySelector('.table'));
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                FileSaver.saveAs(
                    new Blob([wbout], {
                        type: 'application/octet-stream'
                    }),
                    this.$t('pages.washingReport.title') + name + '.xlsx'
                );
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout);
            }
            return wbout;
        },
        indexMethod(index) {
            return index + 1;
        },
    },

};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.toptotalWeight {
    float: right;
    margin-left: 30px;
}
</style>
